import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";
import { FormikProps } from "formik";
import { BillingPreferencesValues } from "pages/Settings/Cards/PaymentsAndInvoicing";
import { Col, Row } from "reactstrap";

interface PaymentInfoProps {
  validation: FormikProps<BillingPreferencesValues>;
  rateOptions: { label: string; value: number }[];
  loading?: boolean;
}

const BillingPreferences = ({
  validation,
  rateOptions,
  loading,
}: PaymentInfoProps) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
      action="#"
    >
      <Row>
        <Col md="12" className="mt-4">
          <CustomInput
            label="Default VAT Rate (%)"
            placeholder="Enter vat rate"
            type="select"
            name="vatRate"
            value={validation.values.vatRate}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            touched={validation.touched.vatRate}
            error={validation.errors.vatRate}
            dropdownOptions={rateOptions}
          />
          <CustomInput
            label="Quote Expiry (Days)"
            placeholder="Enter quote expiry"
            type="number"
            name="quoteExpiry"
            value={validation.values.quoteExpiry}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            touched={validation.touched.quoteExpiry}
            error={validation.errors.quoteExpiry}
          />
          <CustomInput
            label="Payment Terms (Days)"
            placeholder="Enter payment terms"
            type="number"
            name="paymentTerms"
            value={validation.values.paymentTerms}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            touched={validation.touched.paymentTerms}
            error={validation.errors.paymentTerms}
          />

          <Col md="12" className="mt-4 pt-2">
            <CustomButton
              text="Save Changes"
              type="submit"
              className="bg-primary br-7"
              loading={loading}
            />
          </Col>
        </Col>
      </Row>
    </form>
  );
};

export default BillingPreferences;
